'use client';

import { useMatchData } from "@/hooks/useMatchData";
import HeadToHead from "../HeadToHead";


const MatchAnalysis = ({ matchId }) => {
  
  return (
    <>
    <HeadToHead matchId={matchId}/>
    </>
  )
};
export default MatchAnalysis;